import { render } from "./SaturdayChallengeContent.vue?vue&type=template&id=4e479a52&scoped=true"
import script from "./SaturdayChallengeContent.vue?vue&type=script&lang=js"
export * from "./SaturdayChallengeContent.vue?vue&type=script&lang=js"

import "./SaturdayChallengeContent.vue?vue&type=style&index=0&id=4e479a52&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e479a52"]])

export default __exports__